module.exports = __webpack_public_path__ + "static/media/document.20642cdc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/document.svg
// module id = 1329
// module chunks = 0